import { createQuestionValueMap, getUpdatedItems, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

export const defaultRiskyActivitiesInformation: Map<string, ConfirmationData> = new Map([
    ["afa628f2-a03b-417a-b42a-3920b7580e9c", { fontWeight: "bold" }],
    ["a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt1", { type: "checkbox" }],
    ["a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt2", { type: "checkbox" }],
    ["a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt3", { type: "checkbox" }],
    ["a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt4", { type: "checkbox" }],
    ["a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt5", { type: "checkbox" }],
    ["a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt6", { type: "checkbox" }],
    ["a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt7", { type: "checkbox" }],
    ["a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt8", { type: "checkbox" }],
    ["a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt9", { type: "checkbox" }],
    ["a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt10", { type: "checkbox" }],
    ["a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt11", { type: "checkbox" }],
]);
export const diving: Map<string, ConfirmationData> = new Map([
    ["a355bd16-8832-41e4-937a-73877af98f1e", { fontWeight: "bold", color: "skyblue" }],
    ["e9d7ac23-7829-459f-9a78-c1c53036df74", { fontWeight: "bold" }],
    ["3bfc3c6b-7901-4569-8a03-093c8d904188-opt0", { type: "checkbox" }],
    ["3bfc3c6b-7901-4569-8a03-093c8d904188-opt1", { type: "checkbox" }],
    ["3bfc3c6b-7901-4569-8a03-093c8d904188-opt2", { type: "checkbox" }],
    ["3bfc3c6b-7901-4569-8a03-093c8d904188-opt3", { type: "checkbox" }],
    ["3bfc3c6b-7901-4569-8a03-093c8d904188-opt4", { type: "checkbox", showBorder: true }],
    ["fa89b432-c338-4754-aa7a-baf7c1932d16|6866d723-588b-46b5-8dfa-75c70123db8f", { showBorder: true, hiddenIfEmpty: true }],
    ["1bde1702-6dcc-4742-a390-5fedcb68ac38|6866d723-588b-46b5-8dfa-75c70123db8f", { showBorder: true, hiddenIfEmpty: true }],
    ["7e4ecf0f-49e1-4bab-b5a0-b90183061ae5", { fontWeight: "bold" }],

]);

const defaultCertItems: Map<string, ConfirmationData> = new Map([
    ["f83df3a4-7392-4b44-9deb-bcedbedfc100", {}],
    ["b7c47281-c74c-4a0d-9c74-cb78b074e968", {}],
    ["0d55c92f-3e86-4ae3-a9b8-86c3014ecc16", { showBorder: true }],
]);
export const defaultRiskyActivitiesInformation2: Map<string, ConfirmationData> = new Map([
    ["eee4f378-cef6-42bf-8db7-41fe40a76692", { fontWeight: "bold" }],

]);
const defaultSpecialtyCertItems: Map<string, ConfirmationData> = new Map([
    ["7e249816-a22a-4485-9e0b-7208ea0ad894", {}],
    ["0d55c92f-3e86-4ae3-a9b8-86c3014ecc16", { showBorder: true }],
]);

export const diving2: Map<string, ConfirmationData> = new Map([
    ["957ad9db-5a0f-4019-9353-5358b0cb048f", { fontWeight: "bold" }],
    ["f34e8aa2-846f-4c19-b91b-a4ae91b2189b|09ac849f-b173-45fb-84e4-a89c87b430ff", {}],
    ["f34e8aa2-846f-4c19-b91b-a4ae91b2189b|9e7ff0ce-f302-41d6-9641-a70568afcc06", { showBorder: true }],
    ["34e779b3-2d24-4a67-ae60-f301fb2b6154", { fontWeight: "bold" }],
    ["acd3da0f-5340-4508-8276-16abc41ef2cc-m", { label: "Promedio de profundidad" }],
    ["8ba43f0f-5475-40a3-8ea4-37d33fdbc6ad-m", { label: "Profundidad máxima" }],
    ["edfb0e55-873c-4e9d-96d8-7b663543d8cc|9ec0888b-1347-44a5-99ea-13bba0bf7f4d", {}],
    ["edfb0e55-873c-4e9d-96d8-7b663543d8cc|8376caef-6a46-4cc7-b236-524fe8abca30", {}],
    ["edfb0e55-873c-4e9d-96d8-7b663543d8cc|e609585b-6526-4cc3-a110-4afba1abd08a", {}],
    ["edfb0e55-873c-4e9d-96d8-7b663543d8cc|2919856b-c575-4f72-ba40-46e0635a44ed", { showBorder: true }],
    ["bae32979-2e6f-49aa-8381-70d6c986126e", { fontWeight: "bold" }],
]);

const divingLocation: Map<string, ConfirmationData> = new Map([
    ["be41a8ba-e92c-4d17-a1b0-341787046589", {}],
    ["f71537b2-4802-4999-bb68-ad1265658576", { showBorder: true }],
]);

export const diving3: Map<string, ConfirmationData> = new Map([
    ["a73745b8-8216-44ee-8402-aa46c10c7236", { fontWeight: "bold" }],
    ["f5cb6bdf-3a17-46cb-b211-caf100b7c09e|454cfcb1-d6bc-4e5b-bb19-2b85f6bae8df", { label: "Sí/No", showBorder: true }],
]);

export const diving3Items: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Tipo de buceo", fontWeight: "bold" }],
    ["c04a2128-6aeb-4d2a-b72c-ded358cedb3c", {}],
    ["be41a8ba-e92c-4d17-a1b0-341787046589", {}],
    ["f71537b2-4802-4999-bb68-ad1265658576", { showBorder: true }],
]);

export const diving4: Map<string, ConfirmationData> = new Map([
    ["034fdff0-cd8d-4a21-adbb-56976d59d736", { fontWeight: "bold" }],
    ["b7e3ef6e-dbdd-4e56-8351-154d3251abd8|dbc2de67-429e-44ce-a172-0c9ac6c6a55a", { label: "Sí/No" }],
    ["165fbc86-e194-4309-9265-5c52a91577ed|be41a8ba-e92c-4d17-a1b0-341787046589", { hiddenIfEmpty: true }],
    ["165fbc86-e194-4309-9265-5c52a91577ed|f71537b2-4802-4999-bb68-ad1265658576", { hiddenIfEmpty: true }],
    ["165fbc86-e194-4309-9265-5c52a91577ed|090100ce-b72f-4c92-a008-d542ac94bb33", { showBorder: true, hiddenIfEmpty: true }],
]);

export const diving5: Map<string, ConfirmationData> = new Map([
    ["61dd75fc-1843-4d23-bf0c-bd740fc09299", { fontWeight: "bold" }],
    ["ccc66785-0bd8-496d-b064-6713f239498d|1d1e32fa-0063-4aa6-b6fd-c546713d5328", { label: "Sí/No" }],
    ["b960349c-eb18-4967-aee4-070809f3636d|064ed464-d135-40a1-87bb-da6304ba7c62", { hiddenIfEmpty: true }],
    ["b960349c-eb18-4967-aee4-070809f3636d|5365da7d-63e5-4483-a68e-ba2688862c73", { showBorder: true, hiddenIfEmpty: true }],

    ["7e9c0ea3-bd49-4f13-b49f-c6b1cca90fad", { fontWeight: "bold" }],
    ["ee4dcd63-7c77-4243-9556-ed82fde8a0d8|2e6febcd-d4d5-427a-918c-e1d728306203", { label: "Sí/No" }],
    ["c223178e-8583-4c33-948c-3e787a06f951|6baa2032-2d8a-4022-9202-a84d31266c46", { label: "Brinda detalles", showBorder: true, hiddenIfEmpty: true }],

    ["3d52c2f2-8d4b-47fc-9f31-1407eb3d9dcf", { fontWeight: "bold" }],
    ["98b5e71f-98c6-4f27-a1a6-f64049cb3307|79a67db8-d2f5-4966-8052-7f45c3a432a9", { label: "Sí/No" }],
    ["e3321c2e-44a9-48cd-8ed2-25b985e488a0|6baa2032-2d8a-4022-9202-a84d31266c46", { hiddenIfEmpty: true }],
    ["e3321c2e-44a9-48cd-8ed2-25b985e488a0|99a4cc3c-f1e9-40be-b290-37e45b576c4f", { showBorder: true, hiddenIfEmpty: true }],
]);

export const mont1: Map<string, ConfirmationData> = new Map([
    ["20d633dc-f3e5-456d-bfd6-69d971df3622", { fontWeight: "bold", color: "skyblue" }],
    ["cd1486e6-f958-4810-ad7b-1f34221d934f", { fontWeight: "bold" }],
    ["ebaf4574-0e4d-4201-ae2e-e30a17c30b81-opt0", { type: "checkbox" }],
    ["ebaf4574-0e4d-4201-ae2e-e30a17c30b81-opt1", { type: "checkbox" }],
    ["ebaf4574-0e4d-4201-ae2e-e30a17c30b81-opt2", { type: "checkbox" }],
    ["ebaf4574-0e4d-4201-ae2e-e30a17c30b81-opt3", { type: "checkbox" }],
    ["ebaf4574-0e4d-4201-ae2e-e30a17c30b81-opt4", { type: "checkbox" }],
    ["ebaf4574-0e4d-4201-ae2e-e30a17c30b81-opt5", { type: "checkbox" }],
    ["ebaf4574-0e4d-4201-ae2e-e30a17c30b81-opt6", { type: "checkbox" }],
    ["ebaf4574-0e4d-4201-ae2e-e30a17c30b81-opt7", { type: "checkbox" }],
    ["f89e83da-a051-461b-b019-4a5fb2c44ff6|6866d723-588b-46b5-8dfa-75c70123db8f", { fontWeight: "bold", showBorder: true, hiddenIfEmpty: true }],
    ["e194b91b-5af0-421c-9a2e-fc29e0b0786a", { fontWeight: "bold" }],
    ["4977bb17-45d4-4619-917d-a38e2f3f856c-opt0", { type: "checkbox" }],
    ["4977bb17-45d4-4619-917d-a38e2f3f856c-opt1", { type: "checkbox" }],
    ["4977bb17-45d4-4619-917d-a38e2f3f856c-opt2", { type: "checkbox" }],
    ["4977bb17-45d4-4619-917d-a38e2f3f856c-opt3", { type: "checkbox" }],
    ["d8163da9-62cb-47ed-8430-0ae83647f60c|6866d723-588b-46b5-8dfa-75c70123db8f", { fontWeight: "bold", showBorder: true, hiddenIfEmpty: true }],
    ["98b851c3-8118-4a67-bd59-5ab8d41ae41a", { fontWeight: "bold" }],
    ["1fe090af-94d8-4a6b-9248-25a0b33a6ef7|78940754-d41c-46ea-8525-af8cac21fc77", { showBorder: true, hiddenIfEmpty: true }],
    ["9cde201e-2b41-45d8-afb5-f1189ce2023b", { fontWeight: "bold" }],
    ["387c6c68-1c50-415f-94af-23d04151596a|9cf735bf-64a1-4db1-8439-cdf9fcc9522d", { hiddenIfEmpty: true }],
    ["387c6c68-1c50-415f-94af-23d04151596a|5cf31b5b-e3a9-48eb-ac9e-93c42aa32704", { showBorder: true, hiddenIfEmpty: true }],
    ["cb47fe2b-7dc6-437e-8648-d91a40dcf524", { fontWeight: "bold" }],
    ["756680c7-16f5-44ae-9eda-6ad3e59c3686|f674b58f-01d1-4918-b5f3-f33e5e0607cf", { showBorder: true, hiddenIfEmpty: true }],
    ["796063be-19e1-4c75-beac-f4251cb7f456", { fontWeight: "bold" }],
]);

export const climbing: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Locación", fontWeight: "bold" }],
    ["0c532f96-499e-4a2b-815e-d1bab15996b6", { hiddenIfEmpty: true }],
    ["5d53df44-0a54-47cd-8f6d-b539d052d355", { hiddenIfEmpty: true }],
    ["909db55c-cb02-4d7e-81b0-01aaea0539b8", { showBorder: true, hiddenIfEmpty: true }],
]);

export const mont2: Map<string, ConfirmationData> = new Map([
    ["d980ee56-9cfc-40b9-8b0c-019fc28dbdd3", { fontWeight: "bold" }],
    ["6db29b56-7ad1-4606-ab99-e199735dc942", { label: "Sí/No" }],
    ["f17ee245-653e-42b7-bbf4-b7cb8fffc10d|78940754-d41c-46ea-8525-af8cac21fc77", { showBorder: true, hiddenIfEmpty: true }],

    ["ba26a166-0b2c-47d5-825c-e069d1720aa1", { fontWeight: "bold" }],
    ["f6e4e261-9ae2-4d59-9f24-a7759bbb6b30", { label: "Sí/No" }],
    ["cf8816dc-5fb1-44ba-beb1-d03d286448d2|78940754-d41c-46ea-8525-af8cac21fc77", { showBorder: true, hiddenIfEmpty: true }],

    ["76edcfd6-b8a5-49d0-94d8-bd695a256dcf", { fontWeight: "bold" }],
    ["39badfa1-9c29-4353-ace8-347c6d33c813", { label: "Sí/No" }],
    ["45e3b825-7991-4d20-a559-c244ece843a3|bd95e6f1-f0b5-4c12-a0d8-f8031456363d", { hiddenIfEmpty: true }],
    ["45e3b825-7991-4d20-a559-c244ece843a3|99a4cc3c-f1e9-40be-b290-37e45b576c4f", { showBorder: true, hiddenIfEmpty: true }],
]);

export const updateRiskyActivitiesInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    const answersMap = createQuestionValueMap(page);
    if (answersMap.get("a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt4")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...diving
        ]);

        const itemsCertUpdated = getUpdatedItems(page, "7e4ecf0f-49e1-4bab-b5a0-b90183061ae5", "89a46404-fd9a-4bb7-8d4e-dd22c31179bb", defaultCertItems, false);
        cd = new Map([...cd, ...itemsCertUpdated]);

        cd = new Map([
            ...cd,
            ...defaultRiskyActivitiesInformation2
        ]);

        const itemsSpecialtyCertUpdated = getUpdatedItems(page, "eee4f378-cef6-42bf-8db7-41fe40a76692", "fd876385-9e14-42b9-9a33-e623cc0ce752", defaultSpecialtyCertItems, false);
        cd = new Map([...cd, ...itemsSpecialtyCertUpdated]);

        cd = new Map([
            ...cd,
            ...diving2
        ]);

        const itemsDivingLocationUpdated = getUpdatedItems(page, "bae32979-2e6f-49aa-8381-70d6c986126e", "707c5acb-207e-42e6-ab4a-ee28880d11d5", divingLocation, false);

        cd = new Map([...cd, ...itemsDivingLocationUpdated]);

        cd = new Map([
            ...cd,
            ...diving3
        ]);

        const itemsDiving3Updated = getUpdatedItems(page, "2e6ca4b0-dd33-48e2-92b1-95489845aaa4", "cff312fb-4263-436b-a5b3-591a46405721", diving3Items, false);
        cd = new Map([...cd, ...itemsDiving3Updated]);

        cd = new Map([
            ...cd,
            ...diving4
        ]);

        cd = new Map([
            ...cd,
            ...diving5
        ]);
    }

    if (answersMap.get("a1794961-3f8d-43c5-8007-6f8f1a36b4ed-opt5")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...mont1
        ]);

        const itemsClimbingUpdated = getUpdatedItems(page, "796063be-19e1-4c75-beac-f4251cb7f456", "d0422e9b-4746-4ff9-b89a-4789913b116f", climbing, false);
        cd = new Map([...cd, ...itemsClimbingUpdated]);

        cd = new Map([
            ...cd,
            ...mont2
        ]);
    }

    return updateMapWithFields(mapToTupleArray(answersMap), cd);
}

